import { useState, useEffect } from "react";

const minWidthForMobileView = 769;

const useDynamicDimension = (url) => {
  const [screenSize, getDimension] = useState({
    dynamicWidth: window.innerWidth,
    dynamicHeight: window.innerHeight,
    isMobileView: window.innerWidth < minWidthForMobileView,
    dynamicCurrentGrid: 
      window.innerWidth < 229 ? 1 : 
      window.innerWidth >= 229 && window.innerWidth < 334 ? 2 : 
      window.innerWidth >= 334 && window.innerWidth < 439 ? 3 : 
      window.innerWidth >= 439 && window.innerWidth < 544 ? 4 :
      window.innerWidth >= 544 && window.innerWidth < 649 ? 5 : 
      window.innerWidth >= 649 ? 6 : 3
  });

const setDimension = () => {
    getDimension({
      dynamicWidth: window.innerWidth,
      dynamicHeight: window.innerHeight,
      isMobileView: window.innerWidth < minWidthForMobileView,
      dynamicCurrentGrid: 
        window.innerWidth < 229 ? 1 : 
        window.innerWidth >= 229 && window.innerWidth < 334 ? 2 : 
        window.innerWidth >= 334 && window.innerWidth < 439 ? 3 : 
        window.innerWidth >= 439 && window.innerWidth < 544 ? 4 :
        window.innerWidth >= 544 && window.innerWidth < 649 ? 5 : 
        window.innerWidth >= 649 ? 6 : 3
    })
  }


  useEffect(() => {
    window.addEventListener('resize', setDimension);

    return(() => {
        window.removeEventListener('resize', setDimension);
    });

  }, [screenSize]);

  return screenSize;
};

export default useDynamicDimension;
